import { createApiRef } from '@backstage/core-plugin-api';
import {
  ExecuteActionOptions,
  ExecuteActionAllOptions,
  ExecuteActionResponse,
  ResourceDetailsType,
  ListComputeResourceOptions,
  GetKubernetesNamespacesResponse,
} from './types';

export const computeResourceDiscoveryApiRef =
  createApiRef<ComputeResourceDiscoveryApi>({
    id: 'plugin.computeresourcediscovery.service',
  });

export type ComputeResourceDiscoveryApi = {
  listResources: (
    options: ListComputeResourceOptions,
  ) => Promise<ResourceDetailsType[]>;
  executeAction: (
    options: ExecuteActionOptions,
  ) => Promise<ExecuteActionResponse>;
  executeAllAction: (
    options: ExecuteActionAllOptions,
  ) => Promise<ExecuteActionResponse>;
  getKubernetesNamespaceAnnotations: (
    options: ListComputeResourceOptions,
  ) => Promise<GetKubernetesNamespacesResponse>;
  invalidateCache: (pattern?: string) => void;
  getCacheStats: () => { size: number; keys: string[] };
};
